/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import AppTopbar from './AppTopbar';
import AppFooter from './AppFooter';
import AppConfig from './AppConfig';
import AppRightMenu from './AppRightMenu';
// import AppBreadcrumb from './AppBreadcrumb';
import AppMenu from './AppMenu';
import { getPermissionsOfPages } from './utilities/PagePermissions';

import Dashboard from './components/Dashboard';
import Login from './pages/Login';

import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import Customers from './pages/Customers/Customers';
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import LoginScreen from './pages/Login';
import ForgetPassword from './pages/ForgetPassword';
import LoadingOverlay from 'react-loading-overlay';
import TransactionStatus from './pages/TransactionStatus/TransactionStatus';
import BankInfo from './pages/Profile/BankInfo';
import Profile from './pages/Profile/Profile';
import GeneralInfo from './pages/Profile/GeneralInfo';
import BusinessInfo from './pages/Profile/BusinessInfo';
import Live from './pages/Live/Live';
import Outlets from './pages/OutletsManagement/OutletsManagement';
import LiveArchived from './pages/LiveArchived/LiveArchived';
import CaptureVoid from './pages/CaptureVoid/CaptureVoid';
import PaymentNotifications from './pages/PaymentNotifications/PaymentNotifications';
import RefundRequests from './pages/RefundRequests/RefundRequests';
import Refund from './pages/Refund/Refund';
import RefundArchived from './pages/RefundArchived/RefundArchived';
import ContactDetails from './pages/ContactDetails/ContactDetials';
import UserManagement from './pages/UserManagement/UserManagement';
import QrCodes from './pages/QrCodes/QrCodes';
import RefundAdjustment from './pages/RefundAdjustment/RefundAdjustment';
import Hold from './pages/Hold/Hold';
import ChargeBack from './pages/ChargeBack/ChargeBack';
import InvoiceTransaction from './pages/InvoiceTransaction/InvoiceTransaction';
import ViewTicket from './pages/Tickets/ViewTicket';
import CreateTicket from './pages/Tickets/CreateTicket';
import SettlementSummary from './pages/SettlementSummary/SettlementSummary';
import TransactionDetails from './pages/TransactionDetails/TransactionDetails';
import ArchivedTransactionDetails from './pages/ArchivedTransactionDetails/ArchivedTransactionDetails';
import QRPayments from './pages/QRpayments/QRPayments';
import ReturnRequest from './pages/ReturnRequests/ReturnRequest';
import AddQRCode from './pages/QrCodes/AddQRCode';
import Roles from './pages/Roles/Roles';
import Reports from './pages/Reports/LiveReports';
import EditRole from './pages/Roles/EditRole';
import ViewRole from './pages/Roles/ViewRole';
import AddRole from './pages/Roles/AddRole';
import Tickets from './pages/Tickets/Tickets';
import EditTicket from './pages/Tickets/EditTicket';
import QRReports from './pages/Reports/QRReports';
import ArchivedReports from './pages/Reports/ArchivedReports';
import ViewBrandingImage from './pages/Profile/ViewBrandingImage';
import { pagePermissionsSlice } from './redux/slices/pagePermissionsSlice';

const App = (props) => {
    const [rightMenuActive, setRightMenuActive] = useState(false);
    const [configActive, setConfigActive] = useState(false);
    const [menuMode, setMenuMode] = useState('sidebar');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [ripple, setRipple] = useState(true);
    const [sidebarStatic, setSidebarStatic] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [searchActive, setSearchActive] = useState(false);
    const [topbarMenuActive, setTopbarMenuActive] = useState(false);
    const [sidebarActive, setSidebarActive] = useState(false);
    const [pinActive, setPinActive] = useState(false);
    const [activeInlineProfile, setActiveInlineProfile] = useState(false);
    const [resetActiveIndex, setResetActiveIndex] = useState(null);
    const [path, setPath] = useState(null);
    const [navMenu, setNavMenu] = useState(null);

    const copyTooltipRef = useRef();
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isLoading = useSelector((state) => state?.utilitySlice?.isLoading);

    PrimeReact.ripple = true;

    const user = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        if (user && !navMenu) {
            const menu = user?.data?.permissions.map((module) => ({
                label: module.ModuleName,
                icon: module.ModuleIcon,
                to: module.ModulePath,
                insertAllowed: module.Create ? 'Y' : 'N',
                viewAllowed: module.View ? 'Y' : 'N',
                updateAllowed: module.Edit ? 'Y' : 'N',
                deleteAllowed: module.Delete ? 'Y' : 'N'
            }));
            setNavMenu(menu);
        }
    }, [user]);

    useEffect(() => {
        if (path && navMenu) {
            if (path !== '/') {
                // const findingMainMenu = navMenu?.filter((mainItem) => mainItem?.to?.toLowerCase() === path?.toLowerCase());
               const cleanPath = path.split('?')[0]; // remove query params

const findingMainMenu = navMenu?.filter(
    (mainItem) => mainItem?.to?.toLowerCase() === cleanPath?.toLowerCase()
);
                const finding = findingMainMenu?.length > 0 || path?.toLowerCase()?.includes('add') || path?.toLowerCase()?.includes('edit') || path?.toLowerCase()?.includes('view') ? 'done' : '';
                if (finding !== 'done') {
                    navigate('/');
                }
            } else if (user) {
                navigate('/');
            }

            dispatch(pagePermissionsSlice({ permissions: getPermissionsOfPages(navMenu, path) }));
        }
    }, [navMenu, path]);

    // useEffect(() => {
    //     setPath(window.location.href?.split('/#')?.pop());
    // }, [window.location.href]); // eslint-disable-line react-hooks/exhaustive-deps

useEffect(() => {
    setPath(window.location.pathname);  // ✅ query params hata diye
}, [location]);


    let rightMenuClick;
    let configClick;
    let menuClick;
    let searchClick = false;
    let topbarItemClick;

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    useEffect(() => {
        setResetActiveIndex(true);
        setMenuActive(false);
    }, [menuMode]);

    const onDocumentClick = () => {
        if (!searchClick && searchActive) {
            onSearchHide();
        }

        if (!topbarItemClick) {
            setTopbarMenuActive(false);
        }

        if (!menuClick) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
                setResetActiveIndex(true);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                setOverlayMenuActive(false);
                setStaticMenuMobileActive(false);
            }

            hideOverlayMenu();
            unblockBodyScroll();
        }

        if (!rightMenuClick) {
            setRightMenuActive(false);
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        topbarItemClick = false;
        menuClick = false;
        configClick = false;
        rightMenuClick = false;
        searchClick = false;
    };

    const onSearchHide = () => {
        setSearchActive(false);
        searchClick = false;
    };

    const onMenuModeChange = (menuMode) => {
        setMenuMode(menuMode);
        setOverlayMenuActive(false);
    };

    const onRightMenuButtonClick = () => {
        rightMenuClick = true;
        setRightMenuActive(true);
    };

    const onRightMenuClick = () => {
        rightMenuClick = true;
    };

    const onRightMenuActiveChange = (active) => {
        setRightMenuActive(active);
    };

    const onConfigClick = () => {
        configClick = true;
    };

    const onConfigButtonClick = (event) => {
        setConfigActive((prevState) => !prevState);
        configClick = true;
        event.preventDefault();
    };

    const onRippleChange = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;

        if (isOverlay()) {
            setOverlayMenuActive((prevState) => !prevState);
        }

        if (isDesktop()) {
            setStaticMenuDesktopInactive((prevState) => !prevState);
        } else {
            setStaticMenuMobileActive((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
    };

    const onTopbarItemClick = (event) => {
        topbarItemClick = true;
        setTopbarMenuActive((prevState) => !prevState);
        hideOverlayMenu();
        event.preventDefault();
    };

    const onToggleMenu = (event) => {
        menuClick = true;

        if (overlayMenuActive) {
            setOverlayMenuActive(false);
        }

        if (sidebarActive) {
            setSidebarStatic((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const onSidebarMouseOver = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setSidebarActive(isDesktop());
            setTimeout(() => {
                setPinActive(isDesktop());
            }, 200);
        }
    };

    const onSidebarMouseLeave = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setTimeout(() => {
                setSidebarActive(false);
                setPinActive(false);
            }, 250);
        }
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onChangeActiveInlineMenu = (event) => {
        setActiveInlineProfile((prevState) => !prevState);
        event.preventDefault();
    };

    const onRootMenuItemClick = () => {
        setMenuActive((prevState) => !prevState);
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();
            setResetActiveIndex(true);
        }

        if (!event.item.items && (isHorizontal() || isSlim())) {
            setMenuActive(false);
        }
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isOverlay = () => {
        return menuMode === 'overlay';
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    const onInputClick = () => {
        searchClick = true;
    };

    const breadcrumbClick = () => {
        searchClick = true;
        setSearchActive(true);
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const layoutClassName = classNames('layout-wrapper', {
        'layout-static': menuMode === 'static',
        'layout-overlay': menuMode === 'overlay',
        'layout-overlay-active': overlayMenuActive,
        'layout-slim': menuMode === 'slim',
        'layout-horizontal': menuMode === 'horizontal',
        'layout-active': menuActive,
        'layout-mobile-active': staticMenuMobileActive,
        'layout-sidebar': menuMode === 'sidebar',
        'layout-sidebar-static': menuMode === 'sidebar' && sidebarStatic,
        'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static',
        'p-ripple-disabled': !ripple
    });

    return (
        <div className={layoutClassName} onClick={onDocumentClick}>
            <LoadingOverlay active={isLoading} spinner text="Please Wait ...">
                <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
                {!user ? (
                    <Routes>
                        <Route path="*" element={<LoginScreen />} />
                        <Route path="/forget-password" element={<ForgetPassword />} />
                    </Routes>
                ) : (
                    <>
                        <div className="layout-main">
                            <AppTopbar
                                items={navMenu}
                                menuMode={menuMode}
                                colorScheme={props.colorScheme}
                                menuActive={menuActive}
                                topbarMenuActive={topbarMenuActive}
                                activeInlineProfile={activeInlineProfile}
                                onTopbarItemClick={onTopbarItemClick}
                                onMenuButtonClick={onMenuButtonClick}
                                onSidebarMouseOver={onSidebarMouseOver}
                                onSidebarMouseLeave={onSidebarMouseLeave}
                                onToggleMenu={onToggleMenu}
                                onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                                onMenuClick={onMenuClick}
                                onMenuItemClick={onMenuItemClick}
                                onRootMenuItemClick={onRootMenuItemClick}
                                resetActiveIndex={resetActiveIndex}
                            />

                            <AppMenu
                                model={navMenu}
                                onRootMenuItemClick={onRootMenuItemClick}
                                onMenuItemClick={onMenuItemClick}
                                onToggleMenu={onToggleMenu}
                                onMenuClick={onMenuClick}
                                menuMode={menuMode}
                                colorScheme={props.colorScheme}
                                menuActive={menuActive}
                                sidebarActive={sidebarActive}
                                sidebarStatic={sidebarStatic}
                                pinActive={pinActive}
                                onSidebarMouseLeave={onSidebarMouseLeave}
                                onSidebarMouseOver={onSidebarMouseOver}
                                activeInlineProfile={activeInlineProfile}
                                onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                                resetActiveIndex={resetActiveIndex}
                            />

                            {/* <AppBreadcrumb
                            routes={routes}
                            onMenuButtonClick={onMenuButtonClick}
                            menuMode={menuMode}
                            onRightMenuButtonClick={onRightMenuButtonClick}
                            onInputClick={onInputClick}
                            searchActive={searchActive}
                            breadcrumbClick={breadcrumbClick}
                        /> */}

                            <div className="layout-main-content">
                                <Routes>
                                    <Route path="/" exact="true" element={<Dashboard />} />
                                    <Route path="/login" exact="false" element={<Login />} />
                                    <Route path="/bankInfo" exact="false" element={<BankInfo />} />
                                    <Route path="/transaction-status" exact="false" element={<TransactionStatus />} />
                                    <Route path="/business" exact="false" element={<BusinessInfo />} />
                                    <Route path="/profile" exact="false" element={<Profile />} />
                                    <Route path="/generalInfo" exact="false" element={<GeneralInfo />} />
                                    <Route path="/live" exact="false" element={<Live />} />
                                    <Route path="/live-archived" exact="false" element={<LiveArchived />} />
                                    <Route path="/capture-void" exact="false" element={<CaptureVoid />} />
                                    <Route path="/payment-notifications" exact="false" element={<PaymentNotifications />} />
                                    <Route path="/refund-requests" exact="false" element={<RefundRequests />} />
                                    <Route path="/refund" exact="false" element={<Refund />} />
                                    <Route path="/refund-archived" exact="false" element={<RefundArchived />} />
                                    <Route path="/refund-adjustment" exact="false" element={<RefundAdjustment />} />
                                    <Route path="/hold" exact="false" element={<Hold />} />
                                    <Route path="/roles-permissions" exact="false" element={<Roles />} />
                                    <Route path="/add-role" exact="false" element={<AddRole />} />
                                    <Route path="/edit-role" exact="false" element={<EditRole />} />
                                    <Route path="/view-role" exact="false" element={<ViewRole />} />
                                    <Route path="/charge-back" exact="false" element={<ChargeBack />} />
                                    <Route path="/invoice-transaction" exact="false" element={<InvoiceTransaction />} />
                                    <Route path="/customers" exact="false" element={<Customers />} />
                                    <Route path="/outlets" exact="false" element={<Outlets />} />
                                    <Route path="/contact-details" exact="false" element={<ContactDetails />} />
                                    <Route path="/user-management" exact="false" element={<UserManagement />} />
                                    <Route path="/qr-codes" exact="false" element={<QrCodes />} />
                                    <Route path="/add-qrcode" exact="false" element={<AddQRCode />} />
                                    {/* //Tickets */}
                                    <Route path="/tickets" exact="false" element={<Tickets />} />
                                    <Route path="/create-ticket" exact="false" element={<CreateTicket />} />
                                    <Route path="/edit-ticket" exact="false" element={<EditTicket />} />
                                    <Route path="/view-ticket" exact="false" element={<ViewTicket />} />
                                    <Route path="/settlement-summary" exact="false" element={<SettlementSummary />} />
                                    <Route path="/transaction-details" exact="false" element={<TransactionDetails />} />
                                    <Route path="/archived-transaction-details" exact="false" element={<ArchivedTransactionDetails />} />
                                    <Route path="/qr-payments" exact="false" element={<QRPayments />} />
                                    <Route path="/return-requests" exact="false" element={<ReturnRequest />} />
                                    {/* Reports */}
                                    <Route path="/live-reports" exact="false" element={<Reports />} />
                                    <Route path="/qr-reports" exact="false" element={<QRReports />} />
                                    <Route path="/archive-reports" exact="false" element={<ArchivedReports />} />
                                    {/* Branding */}
                                    <Route path="/view-Branding" exact="false" element={<ViewBrandingImage />} />
                                </Routes>
                            </div>

                            <AppFooter colorScheme={props.colorScheme} />
                        </div>
                    </>
                )}

                <AppRightMenu rightMenuActive={rightMenuActive} onRightMenuClick={onRightMenuClick} onRightMenuActiveChange={onRightMenuActiveChange} />

                <AppConfig
                    configActive={configActive}
                    onConfigButtonClick={onConfigButtonClick}
                    onConfigClick={onConfigClick}
                    menuMode={menuMode}
                    changeMenuMode={onMenuModeChange}
                    colorScheme={props.colorScheme}
                    changeColorScheme={props.onColorSchemeChange}
                    theme={props.theme}
                    changeTheme={props.onMenuThemeChange}
                    componentTheme={props.componentTheme}
                    changeComponentTheme={props.onComponentThemeChange}
                    ripple={ripple}
                    onRippleChange={onRippleChange}
                />
                <ToastContainer />
            </LoadingOverlay>
        </div>
    );
};

export default App;
